import filesStore from 'modules/documents/components/Documents/store'

const getFiles = () => {
  return filesStore.files
}

const deleteAllFiles = () => {
  const length = filesStore.files.length
  filesStore.files.splice(0, length)
}

const onDeleteFile = (i: number) => {
  filesStore.files.splice(i, 1)
}

const addFiles = (files: File[]) => {
  filesStore.concat(files)
}

const useFilesStore = () => {
  return {
    getFiles,
    addFiles,
    onDeleteFile,
    deleteAllFiles,
  }
}

export default useFilesStore
